<template>
    <div class="container">
      <div class="navi">
          <span class="close"><span class="icon-arrow-left" @click="close()"></span></span>
          <div class="top-title">请选择服务日期</div>
          <span></span>
      </div>
          <div class="notice-box" v-show="ifHoliday()">
            <div class="notice-yellow">
              {{holidayWord()}}
            </div>
          </div>
      <datepicker :inline="true" :language="zh" :monday-first="true" v-model="service_date" :initial-view="init_view" :bootstrap-styling="true" :disabledDates="disabledDates" :open-date="tomorrowDate()" v-if="tomorrowDate()!=0"></datepicker>

      <datepicker :inline="true" :language="zh" :monday-first="true" v-model="service_date" :initial-view="init_view" :bootstrap-styling="true" :disabledDates="disabledDates"  v-if="tomorrowDate()==0"></datepicker>

      <div class="timerange" v-bind:class="{ visualhidden: !service_date}">
        <div class="date">请选择时间段:</div>
        <div class="option-btn" @click="service_period = 'am'" v-bind:class="{ active: service_period=='am' }">上午</div>
        <div class="option-btn" @click="service_period = 'pm'" v-bind:class="{ active: service_period=='pm' }">下午</div>
      </div>
      <div class="call-info" :class="{ visualhidden: !(service_period&&service_date)}">
        我们客服随后将向您致电确定<span class="hl">具体时间</span>
      </div>
      <div class="btn active" @click="saveData()" :class="{ visualhidden: !(service_period&&service_date)}">保存时间</div>

    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {zh} from 'vuejs-datepicker/dist/locale'

export default {
  name: 'datepicker-fullpage',
  data () {
    return {
      address:{},
      zh: zh,
      disabledDates:this.outer_disableddates,
      service_date:this.outer_date,
      service_period:this.outer_period,
      open_date:this.outer_opendate,
      init_view:this.outer_initView,
    }
  },
  props: ['outer_date','outer_period','outer_opendate','outer_initView','outer_disableddates'],
  methods: {
    close: function () {
      this.$emit('close')
    },
    saveData: function () {
        this.$emit('change',this.service_date,this.service_period);
    },
    tomorrowDate: function () {
      let today = new Date();
      let tomorrow = new Date();
      let dayAdd = 1;
      if(this.open_date==0){
        return "";
      }
      else{
        if(this.open_date){
          dayAdd = parseInt(this.open_date);
        }
        tomorrow.setDate(today.getDate()+dayAdd);
        return tomorrow;
      }

    },
  },
  components: {
    Datepicker
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container{
  padding-top:0!important;
}


.navi{
    display: flex;
    justify-content:space-between;
    padding:0 0 0 0;
    width:100%;
    background:rgba(255, 255, 255, 0.94);
    span{
        flex: 1;
    }
    div{
        flex:2;
    }
    .close{
        text-align:left;
        font-size:1em;
        .icon-arrow-left{
            margin-right:12px;
            margin-top:12px;
            display:inline-block;
        }
    }
}
.icon-arrow-left{
    padding-left:12pt;
}
.top-title{
    font-size:0.5em;
    line-height:3.2em;
    color:#444;
    vertical-align:top;
    display:inline-block;
    text-align:center;
}

.timerange{
  text-align:center;
  margin-top:20px;
}

.date{
  color:#fe9567;
  display:inline-block;
  font-weight:600;
  font-size:1.1em;
  margin:0 10pt;
}

.option-btn{
  border:2px solid #fe9567;
  border-radius:4px;
  width:68px;
  height:34px;
  line-height:34px;
  color:#ff7444;
  display:inline-block;
  margin:0 4px;
	text-align:center;
}

.option-btn.active{
  border:2px solid #fe9567;
  border-radius:4px;
  width:68px;
  height:34px;
  line-height:34px;
  background-color:#fe9567;
  color:#fff;
  display:inline-block;
  margin:0 4px;
	-webkit-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
	-moz-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
  box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
}

.call-info{
  text-align:center;
  color:#444;
  margin-top:14px;
  .hl{
    color:#fe9567;
  }
}
.container /deep/ .cell.selected{
  background:#EF885E;
  border-radius:30px;
  color:#fff;
}
.container /deep/ .vdp-datepicker__calendar .cell.selected:hover{
  background:#EF885E;
}

.container /deep/ .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover{
  border:0;
}

.container /deep/ .vdp-datepicker__calendar{
    border:0;
    padding:0 20pt;
    width:100%;
}

.container /deep/ .cell.selected:hover{
  border:solid 1px #EF885E;
}

.container /deep/ .cell:hover{
  border:solid 1px #EF885E;
}
</style>



// WEBPACK FOOTER //
// src/components/datepicker/index.vue